import {openPrimaryWorkspace, openSecondaryWorkspace, updateWorkspaceExclusions} from "../../reducers/workspaceSlice"
import { concatUnassignedArticles, removeUnassignedArticles } from "../../reducers/unassignedArticlesEventsSlice"
import { getImportedArticleCountForWorkspace } from "../../reducers/freeTierTrackerslice"
import { pushAttachedArticlesToNoteTab } from "../../reducers/noteArticleTabsV2Slice" 
export const articlesSocketMiddleware = (socket) => {
	// eslint-disable-next-line no-unused-vars
	return storeAPI => {
		socket.on("NEW_UNASSIGNED_ARTICLES", async ({articles, workspaceId}) => {
			storeAPI.dispatch(concatUnassignedArticles({articles, workspaceId}))
			await storeAPI.dispatch(getImportedArticleCountForWorkspace({workspaceId}))
		})
		// "REMOVE_UNASSIGNED_ARTICLE"
		socket.on("REMOVE_UNASSIGNED_ARTICLES", ({articles, workspaceId}) => {
			storeAPI.dispatch(removeUnassignedArticles({articles, workspaceId}))

		})
		// "DELETE_ARTICLES"
		socket.on("DELETE_ARTICLES", ({workspaceId}) => {
			storeAPI.dispatch(getImportedArticleCountForWorkspace({workspaceId}))

		})
		// "ATTACH_NOTE_TO_ARTICLE"
		socket.on("ATTACH_NOTE_TO_ARTICLE", (payload) => {
			storeAPI.dispatch(pushAttachedArticlesToNoteTab(payload))

		})

		//"WORKSPACE_EXCLUSIONS_UPDATED"
		socket.on("WORKSPACE_EXCLUSIONS_UPDATED", (workspaceId) => {
			storeAPI.dispatch(updateWorkspaceExclusions(workspaceId))
		})

		return next => action => {
			if (action.type === "WS_CONNECT") {
				socket.connect()
	
			}
	
			if (action.type === "WS_DISCONNECT") {
				socket.disconnect()
			}
	
			if (action.type === "WS_EMIT") {
				const { event, payload } = action
				socket.emit(event, payload)
			}

			if (
				action.type === openPrimaryWorkspace.fulfilled.type ||
				action.type === openSecondaryWorkspace.fulfilled.type
			) {
				const workspaceId = action.payload.workspace.id
				socket.emit("SUBSCRIBE_TO_ARTICLES", workspaceId)
			}
	
	
			return next(action)
		}
	}
}